import React, { useContext, useState } from "react";
import { Form } from "semantic-ui-react";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { Context } from "../../../context/globalContext";
import { EMAIL_USERNAME_VERIFICATION } from "../../../helpers/graphqlQueries";
import { toast } from "react-toastify";
import { useQuery } from "@apollo/client";
import firebase from "firebase/app";
import "firebase/auth";
import { routes } from "../../../helpers/routes";
import { ThemeProps } from "../../genericComponents/globalStyles";
import { useHistory } from "react-router-dom";
import { Divider } from "antd";
import googleIcon from "../../../assets/images/icons/google.png";
import { trackEvent, trackIdentity } from "../../../helpers/analytics";
import { sendWelcomeEmail } from "../services";
import { CREATE_USER } from "../../../helpers/graphqlMutations";

const googleProvider = new firebase.auth.GoogleAuthProvider();

const SignupSchema = yup.object().shape({
  //name: yup.string().required("First Name is a required field."),
  //last_name: yup.string().required("Last Name is a required field"),
  username: yup
    .string()
    .trim()
    .matches(
      /^[a-zA-Z0-9_.-]+$/,
      "Use only letters, numbers, dots, hyphens and underscores"
    )
    .required("Username is a required field"),
  //medical_school: yup.string().required("Medical School is a required field"),
  //career: yup.string().required("Career is a required field"),
  email: yup
    .string()
    .email("Email format incorrect")
    .required("Email Address is a required field."),
  password: yup
    .string()
    .required("You are required to set a password.")
    .min(8, "Passwords must be a minimum of 8 characters."),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Please confirm your password here."),
});

// const careerList = [
//   "Nursing",
//   "Nurse Practitioner",
//   "Physician Assistant",
//   "Dental Hygienist",
//   "Occupational Therapy",
//   "Optometry",
//   "Occupational Therapy",
//   "Doctor of Chiropractic",
//   "Doctors of naturopathic medicine",
//   "Podiatric Medicine",
//   "Healthcare Administration",
//   "Certified Nursing Assistant",
//   "Certified Medical Assistant",
//   "Medical Scribe",
//   "Speech-Language Pathology",
//   "Veterinary Medicine",
//   "Clinical Psychology",
//   "Clinical Social Work",
//   "Dental Assistant",
//   "Doctor of Dental Surgery",
//   "Doctor of Medicine in Dentistry",
//   "Doctor of Pharmacy",
//   "Registered Dietician",
//   "Doctor of Osteopathic Medicine",
//   "Doctor of Allopathic Medicine",
//   "Phlebotomy",
//   "Other",
// ];

// const careerOptions = careerList.map((option, index) => ({
//   text: option,
//   key: index,
//   value: option,
// }));

export default function SignUp() {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const { graphQLClient } = useContext(Context);
  const [signUpWithFormn, setSignUpWithFormn] = useState(false);

  // useQuery(GET_SCHOOLS, {
  //   onCompleted: (data) =>
  //     setSchools(
  //       data.school_programs.map((school, index) => ({
  //         text: school.school_name,
  //         key: school.index,
  //         value: school.school_name,
  //       }))
  //     ),
  // });

  function capitalizeText(text = "") {
    return text[0].toUpperCase() + text.slice(1).toLowerCase();
  }

  // async function sendVerificationEmail(data) {
  //   const template_params = {
  //     contactEmail: data.email,
  //     contactFirstName: data.username,
  //   };

  //   const service_id = "default_service";
  //   const template_id = "welcome_to_gaba_";
  //   const user_id = "user_yIq3IIfTQ8ruKbjBAqYaQ";
  //   await emailjs.send(service_id, template_id, template_params, user_id);
  // }

  const {
    errors,
    handleChange,
    handleSubmit,
    values,
    setFieldValue,
    touched,
    setFieldTouched,
  } = useFormik({
    initialValues: {
      ...{
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
    },
    validationSchema: SignupSchema,
    onSubmit: onSubmitHandle,
  });

  async function onSubmitHandle(data) {
    setLoading(true);
    try {
      const resultVerify = await verifyEmailAndUsername(
        data.email,
        data.username
      );
      if (!resultVerify) {
        toast.error("Username or Email is already used");
        setLoading(false);
        return;
      }
      const variables = {
        email: data.email.trim().toLowerCase(),
        password: data.password,
        username: data.username.trim().toLowerCase(),
      };
      await graphQLClient
        .mutate({
          variables,
          mutation: CREATE_USER,
        })
        .then((result) => console.log(result));
      sendWelcomeEmail(data);
      await firebase
        .auth()
        .signInWithEmailAndPassword(data.email, data.password);

      trackIdentity(data.email, {
        username: data.username.trim().toLowerCase(),
      });
      trackEvent("Account created", {
        email: data.email.trim().toLowerCase(),
        username: data.username.trim().toLowerCase(),
      });
      window.location.replace(routes.SIGNIN);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error("Unable to sign in with provided data");
    }
  }

  async function verifyEmailAndUsername(email, username) {
    const emailAndUsername = await graphQLClient.query({
      variables: { email, username },
      query: EMAIL_USERNAME_VERIFICATION,
    });
    if (emailAndUsername?.data?.user_account?.length) return false;
    return true;
  }

  function googleAuthHandle() {
    firebase
      .auth()
      .signInWithPopup(googleProvider)
      .then((res) => {
        console.log(res.user);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <RowSpaceBeetwenContainer>
        <HeaderTitle>Join GABA</HeaderTitle>
        <div>
          <AlreadyMemberLabel>Already a member?</AlreadyMemberLabel>
          <SignInButton onClick={() => history.replace(routes.SIGNIN)}>
            Sign In
          </SignInButton>
        </div>
      </RowSpaceBeetwenContainer>
      <Divider
        style={{ borderColor: ThemeProps.color.gabaYellow, borderWidth: "2px" }}
      />

      {!signUpWithFormn ? (
        <>
          <ButtonIcon
            onClick={googleAuthHandle}
            backgroundColor={ThemeProps.color.softGray}
          >
            <img
              src={googleIcon}
              style={{ width: "18px", height: "18px" }}
              alt=''
            />
            <p style={{ display: "flex", flex: 1, justifyContent: "center" }}>
              Join with your Google account
            </p>
          </ButtonIcon>
          <Divider plain>Or</Divider>
          <ButtonIcon
            onClick={() => setSignUpWithFormn(true)}
            backgroundColor={ThemeProps.color.gabaYellow}
          >
            Join with your email address
          </ButtonIcon>
        </>
      ) : (
        <>
          <Form.Field required>
            <Label>Username</Label>
            <ExtraLabel>
              Your username will be displayed on your public profile and
              reviews. It can not be changed later
            </ExtraLabel>
            <input
              //placeholder="@"
              onChange={(e) =>
                setFieldValue("username", e.target.value.replace("@", ""))
              }
              value={values.username}
              type='text'
              name='username'
            />
            {errors.username && touched.username && (
              <span className={"text-danger"}>{errors.username}</span>
            )}
          </Form.Field>
          <Divider />

          <Form.Field required>
            <Label>Email Address </Label>
            <input type='text' onChange={handleChange} name='email' />
            {errors.email && touched.email && (
              <span className={"text-danger"}>{errors.email}</span>
            )}
          </Form.Field>
          <Divider />
          <Form.Group widths='equal'>
            <Form.Field required>
              <Label>Password</Label>
              <input type='password' onChange={handleChange} name='password' />
              {errors.password && touched.password && (
                <span className={"text-danger"}>{errors.password}</span>
              )}
            </Form.Field>
            <Form.Field required>
              <Label>Confirm Password</Label>
              <input
                type='password'
                onChange={handleChange}
                name='confirmPassword'
              />
              {errors.confirmPassword && touched.password && (
                <span className={"text-danger"}>
                  {" "}
                  {errors.confirmPassword}{" "}
                </span>
              )}
            </Form.Field>
          </Form.Group>
          <Divider />

          <Form.Button
            type='submit'
            content='Join GABA'
            fluid
            size='huge'
            active={false}
            loading={loading}
            primary={
              (!Object.keys(errors).length &&
                Object.keys(touched).length !== 0) ||
              false
            }
          />
        </>
      )}
    </FormWrapper>
  );
}

const FormWrapper = styled(Form)`
  margin: 32px auto;
  width: 50%;
  @media (max-width: 991px) {
    width: 70%;
  }
  @media (max-width: 768px) {
    width: 80%;
  }
`;
const Label = styled.label`
  font-size: 1.34em !important;
`;
const ExtraLabel = styled.label`
  font-size: 0.8em !important;
`;

const RowSpaceBeetwenContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const SignInButton = styled.button`
  border: none;
  margin-left: 12px;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: 600;
  background-color: ${ThemeProps.color.gabaGreen}44;
`;
const AlreadyMemberLabel = styled.label`
  font-weight: 600;
  color: #0007;
`;
const HeaderTitle = styled.label`
  font-size: 1.7em;
  font-weight: 600;
`;
const ButtonIcon = styled.button`
  border: none;
  outline: none;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  display: flex;
  justify-content: center;
  font-weight: 600;
  box-shadow: 0px 1px 4px 0px rgba(17, 23, 65, 0.33);
  background-color: ${(p) => p.backgroundColor};
`;
